function discoverHost(devHost?: string) {
  let host = "";

  if (devHost) {
    host = devHost;
  } else if (import.meta.server) {
    host = useRequestHeaders(["host"]).host || "";
  } else {
    host = window?.location?.host;
  }

  return host;
}

export default discoverHost;
